import React from 'react'
import {
	LoaderCore,
	LoaderRingInner,
	LoaderRingOuter,
	LoaderSatellite,
	LoaderWrap,
} from '../ItineraryImportPage.styles'

const OrbitLoader: React.FC<{ size?: number }> = ({ size = 104 }) => (
	<LoaderWrap $size={size}>
		<LoaderRingOuter />
		<LoaderRingInner />
		<LoaderCore $size={size} />
		<LoaderSatellite $size={size} />
	</LoaderWrap>
)

export default OrbitLoader
